import { changedItems } from '../../util/event-log-items.js';
const SETTINGS_NOT_LOGGED = new Set(['id', 'updatedAt', 'updatedBy', 'licence', 'licenceTampered']);
/** Settings on the Printouts tab, labelled `settings.printouts.<key>` in the settings form. */
const PRINTOUT_SETTINGS = new Set([
    'actualQuantity',
    'additionalLabelBarcode',
    'bandTextCytotoxic',
    'bandTextNonCytotoxic',
    'concentration',
    'concentrationBasis',
    'customerName',
    'hospitalNumber',
    'includeEndControlSignatures',
    'includeLabelCopy',
    'labelCopies',
    'labelSize',
    'labelVolume',
    'manufacturer',
    'pharmacyNameAndAddress',
    'preparedBy',
    'prescribingDoctor',
    'printReportAutomatically',
    'showProductCodeColumn',
    'showScaleMemoryNumbers',
    'tradeNameBeforeSubstance',
    'wardNextToCustomerName',
]);
/** Form labels that do not follow `settings.<key>`. */
const LABEL_KEYS = {
    minimumSaveableVolume: 'settings.minimumSaveableVolume.label',
};
/** Translated values of settings that store a code. */
const VALUE_KEYS = {
    bsaFormula: 'event.value.bsa_formula.{value}',
    ibwFormula: 'event.value.aibw_formula.{value}',
};
function labelKey(key) {
    return LABEL_KEYS[key] ?? (PRINTOUT_SETTINGS.has(key) ? `settings.printouts.${key}` : `settings.${key}`);
}
/** One item per changed setting, labelled with its settings form label. */
export function settingsItems(prev, next) {
    const specs = Object.keys(next)
        .filter(key => !SETTINGS_NOT_LOGGED.has(key))
        .map(key => {
        const spec = { field: key, labelKey: labelKey(key) };
        const valueKey = typeof next[key] === 'boolean' ? 'event.value.on_off.{value}' : VALUE_KEYS[key];
        if (valueKey)
            spec.valueKey = valueKey;
        return spec;
    });
    return changedItems(prev, next, specs);
}
//# sourceMappingURL=settings-log-items.js.map